import axios from 'axios'
import Store from '../store'

//export const DEV_ENDPOINT = 'http://validator.test/public/'
//export const  DEV_ENDPOINT = 'https://validator.vurnikov-trg.si/cloud/public/'
//export const  DEV_ENDPOINT = 'https://garaznahisa.vurnikov-trg.si/cloud/public/'
export const DEV_ENDPOINT = 'https://vurnikov-trg.fesst-upravljanje.si/cloud/public/'

export function get(url) {
    return axios({
        method: 'GET',
        url: url,
        headers: {
            'Authorization': `Bearer ${Store.state.api_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function post(url, payload) {
    return axios({
    	method: 'POST',
    	url: url,
    	data: payload,
    	headers: {
            'Authorization': `Bearer ${Store.state.api_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function put(url, payload) {
    return axios({
        method: 'POST',
        url: url,
        data: payload,
        headers: {
            'Authorization': `Bearer ${Store.state.api_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function destroy(url) {
    return axios({
        method: 'POST',
        url: url,
        headers: {
            'Authorization': `Bearer ${Store.state.api_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function interceptors(cb) {
    axios.interceptors.response.use((res) => {
        return res;
    }, (err) => {
        cb(err)
        return Promise.reject(err)
    })
}

export function revoke() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('parkirisce')

    Store.commit('setToken', null);
    Store.commit('setUser', null);
    Store.commit('setUserID', null);
    Store.commit('setParkirisce', null)
}